import { ows } from './ows';

const capabilities = {
	ows
}

export {
	capabilities
}